import { render, staticRenderFns } from "./serviceChargesDetail.vue?vue&type=template&id=c54be872&scoped=true"
import script from "./serviceChargesDetail.vue?vue&type=script&lang=js"
export * from "./serviceChargesDetail.vue?vue&type=script&lang=js"
import style0 from "./serviceChargesDetail.vue?vue&type=style&index=0&id=c54be872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54be872",
  null
  
)

export default component.exports